import { render, staticRenderFns } from "./SliderChangeMethod.vue?vue&type=template&id=4587c5db"
import script from "./SliderChangeMethod.vue?vue&type=script&lang=js"
export * from "./SliderChangeMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports